import detect from './util/antiDebug.js'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import JDialog from './Dialog/index.js'
import './style.css'
import md5 from 'js-md5'
import logger, { LOG_LEVELS } from './util/logger.js'

function startAntiDebug() {
  detect()
  setTimeout(startAntiDebug, 10)
}
if (import.meta.env.PROD) {
  startAntiDebug()
}

const app = createApp(App)
// 将 md5 挂到全局，供各处使用（如 window.md5）
window.md5 = md5

app.use(router)
app.use(JDialog)
app.mount('#app')

// 将日志控制方法挂到全局，方便在控制台使用
// window.logger = {
//   // 启用/禁用日志
//   enable: () => {
//     logger.setEnabled(true)
//     console.log('日志已启用')
//   },
//   disable: () => {
//     logger.setEnabled(false)
//     console.log('日志已禁用')
//   },
//   // 设置日志级别: 'debug', 'info', 'warn', 'error', 'none'
//   setLevel: (level) => {
//     const levelMap = {
//       'debug': LOG_LEVELS.DEBUG,
//       'info': LOG_LEVELS.INFO,
//       'warn': LOG_LEVELS.WARN,
//       'error': LOG_LEVELS.ERROR,
//       'none': LOG_LEVELS.NONE
//     }
//     const logLevel = levelMap[level.toLowerCase()]
//     if (logLevel !== undefined) {
//       logger.setLevel(logLevel)
//       console.log(`日志级别已设置为: ${level}`)
//     } else {
//       console.warn('无效的日志级别，可用值: debug, info, warn, error, none')
//     }
//   },
//   // 获取当前配置
//   getConfig: () => {
//     const config = logger.getConfig()
//     console.log('当前日志配置:', config)
//     return config
//   },
//   // 更新配置
//   updateConfig: (config) => {
//     logger.updateConfig(config)
//     console.log('日志配置已更新:', logger.getConfig())
//   }
// }
